// getters
const cafeteriaReports = state => state.cafeteriaReports

export default {
  cafeteriaReports
}



// WEBPACK FOOTER //
// ./src/store/modules/cafeteria/reports/getters.js